/* AG LIFETIME: the free warranty line (UK Black Friday 2026).

   Code LIFETIME is a discount function in the Spin wheel backend app
   (ag-spin-wheel-app, lifetime-offer): one Lifetime Warranty free per
   pair of Black, Chrome or Core dumbbells, plus GBP 150 off a pair until
   31 Oct. Michael (12 Oct 2026): entering the code adds the warranty, or
   makes it free if it is already in the basket.

   So while LIFETIME is on the cart, keep one warranty per pair: add the
   shortfall as a line tagged _lifetime_auto, and take that line back
   down when the code or the dumbbells go. A warranty the customer added
   is never touched.

   Rules that keep it honest:
   - Never leave a GBP 69 warranty the code is not paying for. After a
     background add, the cart is read back; if LIFETIME is still not
     applicable (a builder bundle saving won, the code ended, used
     before) the line is taken back out and that cart is remembered, so
     it is not added again until the cart or its codes change.
   - Increases are capped per page; reductions always go through (they
     only ever move towards zero, so they cannot loop).
   - Loaded by the cart drawer AND the /cart page (the drawer is not
     rendered there). On /cart (data-reload) a change reloads the page,
     at most 3 times a minute.
   - The drawer's code box (ag-discount-choice.js) calls sync() before a
     typed LIFETIME is checked: from 1 Nov the code only applies once a
     warranty is in the basket. A code typed at checkout cannot reach
     this; the warranty is still free if it is in the basket.
   Every request checks r.ok; writes go through window.AGCart.run. */
(function () {
  'use strict';
  if (window.AGLifetime) return;

  var CODE = 'LIFETIME';
  var WARRANTY_VARIANT_ID = 45418026991866;
  var DUMBBELL_PRODUCT_IDS = [
    8568742904058,  /* Black Edition (Pair) */
    16255240470915, /* Chrome Edition (Gen 6) */
    15580582805891  /* Core Edition 40kg (Pair) */
  ];
  var AUTO_PROP = '_lifetime_auto';
  var MAX_INCREASES = 4;
  var MAX_RELOADS_PER_MIN = 3;
  var REJECTED_KEY = 'agltRejected';
  var RELOADS_KEY = 'agltReloads';

  var script = document.currentScript;
  var reloadMode = !!(script && script.hasAttribute('data-reload'));
  var increases = 0;
  var applying = false;
  var running = false;

  function upper(s) { return String(s || '').toUpperCase(); }

  function cartWrite(fn) {
    return (window.AGCart && typeof window.AGCart.run === 'function') ? window.AGCart.run(fn) : fn();
  }

  function getCart() {
    /* Absolute URL: ag-cart-read-cache replays relative /cart.js reads. */
    return fetch(location.origin + '/cart.js?_aglt=' + Date.now(), { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) {
        if (!r.ok) throw new Error('cart.js ' + r.status);
        return r.json();
      });
  }

  function wait(ms) { return new Promise(function (res) { setTimeout(res, ms); }); }

  /* One POST, retried only on 429, at most 3 times. Callers run it
     inside cartWrite. */
  function rawPost(url, body, attempt) {
    attempt = attempt || 0;
    return fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      if (r.status === 429 && attempt < 3) {
        return wait(600 * (attempt + 1)).then(function () { return rawPost(url, body, attempt + 1); });
      }
      if (!r.ok) throw new Error(url + ' ' + r.status);
      return r.json();
    });
  }

  function lifetimeCode(c) {
    return ((c && c.discount_codes) || []).filter(function (d) { return upper(d.code) === CODE; })[0] || null;
  }

  /* What the cart has and what it should have. Entries sharing a key
     (a code can split one line into two) are summed. */
  function plan(c, withCode) {
    var pairs = 0, manual = 0, autoKey = null, autoQty = 0;
    ((c && c.items) || []).forEach(function (it) {
      if (DUMBBELL_PRODUCT_IDS.indexOf(Number(it.product_id)) !== -1) { pairs += it.quantity; return; }
      if (Number(it.variant_id) !== WARRANTY_VARIANT_ID) return;
      if ((it.properties || {})[AUTO_PROP]) {
        if (!autoKey) autoKey = it.key;
        if (it.key === autoKey) autoQty += it.quantity;
      } else {
        manual += it.quantity;
      }
    });
    var on = withCode || !!lifetimeCode(c);
    return { pairs: pairs, autoKey: autoKey, autoQty: autoQty, want: on ? Math.max(0, pairs - manual) : 0 };
  }

  /* A cart the code turned down: its codes and every line other than
     our own warranty line. Any change to either allows a fresh try. */
  function signature(c) {
    var codes = ((c && c.discount_codes) || []).map(function (d) { return upper(d.code); }).sort();
    var lines = ((c && c.items) || [])
      .filter(function (it) { return !(it.properties || {})[AUTO_PROP]; })
      .map(function (it) { return it.key + ':' + it.quantity; }).sort();
    return codes.join(',') + '|' + lines.join(',');
  }
  function store(k, v) { try { if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v); } catch (e) {} }
  function read(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }

  function setAuto(p, qty) {
    if (p.autoKey) return rawPost('/cart/change.js', { id: p.autoKey, quantity: qty });
    var props = {};
    props[AUTO_PROP] = '1';
    return rawPost('/cart/add.js', { items: [{ id: WARRANTY_VARIANT_ID, quantity: qty, properties: props }] });
  }

  /* One queued read and write. withCode: the drawer is about to apply
     LIFETIME, so add the warranty without waiting for the code (resolve
     in ag-discount-choice.js takes it back if the code then fails).
     Resolves to 'added', 'reduced', 'rejected' or '' (nothing to do). */
  function sync(withCode) {
    return cartWrite(function () {
      return getCart().then(function (c) {
        var p = plan(c, withCode);
        if (p.want === p.autoQty) return '';
        if (p.want < p.autoQty) {
          return setAuto(p, p.want).then(function () { return 'reduced'; });
        }
        if (!withCode && read(REJECTED_KEY) === signature(c)) return '';
        if (increases >= MAX_INCREASES) return '';
        increases += 1;
        var before = p.autoQty;
        return setAuto(p, p.want).then(function () {
          if (withCode) return 'added';
          return getCart().then(function (c2) {
            var d = lifetimeCode(c2);
            if (d && d.applicable) { store(REJECTED_KEY, null); return 'added'; }
            /* Not paying for it: put the line back as it was. */
            var p2 = plan(c2, true);
            var undo = p2.autoKey ? rawPost('/cart/change.js', { id: p2.autoKey, quantity: before }) : Promise.resolve();
            return undo.then(getCart).then(function (c3) {
              store(REJECTED_KEY, signature(c3));
              return 'rejected';
            });
          });
        });
      });
    });
  }

  function redraw(res) {
    if (reloadMode) {
      var now = Date.now();
      var log = [];
      try { log = JSON.parse(read(RELOADS_KEY) || '[]').filter(function (t) { return now - t < 60000; }); } catch (e) {}
      if (log.length >= MAX_RELOADS_PER_MIN) return;
      log.push(now);
      store(RELOADS_KEY, JSON.stringify(log));
      location.reload();
      return;
    }
    var dc = window.AGDiscountChoice;
    var msg = res === 'added' ? { kind: 'success', text: 'Lifetime warranty added free with LIFETIME.' } : undefined;
    if (dc && typeof dc.refresh === 'function') dc.refresh(msg);
    else document.dispatchEvent(new CustomEvent('cart:refresh'));
  }

  /* Background pass (load, drawer refresh). Its own redraw fires
     cart:refresh again, which finds nothing left to do. A 'rejected'
     pass changed nothing visible, so it does not redraw. */
  function pass() {
    var dc = window.AGDiscountChoice;
    if (running || applying || (dc && typeof dc.isBusy === 'function' && dc.isBusy())) return Promise.resolve(false);
    running = true;
    return sync(false).then(function (res) {
      running = false;
      if (res === 'added' || res === 'reduced') redraw(res);
      return !!res;
    }, function () { running = false; return false; });
  }

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(pass, 700);
  }
  document.addEventListener('cart:refresh', schedule);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }

  window.AGLifetime = {
    CODE: CODE,
    sync: sync,
    schedule: schedule,
    pairs: function (c) { return plan(c, true).pairs; },
    setApplying: function (on) { applying = !!on; }
  };
})();
